import { Lock } from '@mui/icons-material';
import { Paper, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import React from 'react';
import { useTranslation } from 'react-i18next';

export default function UnknownSubtopic(props) {

    const {t} = useTranslation()

    return(
        <Paper sx={{display: "flex", justifyContent: "space-between", alignItems: "center", p: 1,
                    backgroundColor: grey[200]}}
        >
            <Lock color="secondary" sx={{width: "30%", height: "30%"}}/>
            <Typography>
                {t("quizUnlockStatement", { quizname: props.lastQuiz })}
            </Typography>
        </Paper>
    )
}